export enum Acl {
  Private = 'private',
  Public = 'public',
}
